export const showSurvey = (moduleName = 'patient-p360') => {
  /* SURVEY START - Trigger Survey */
  (window as any).dispatchEvent(
    new CustomEvent('show-survey', { detail: { moduleName } }),
  );
  /* SURVEY END */
};
